/**
 * Term used to probe `GET /impersonation/users` for the right to impersonate (PUL-2840).
 *
 * The permission is not readable client-side — `admin` is an aggregator, filtered out of what
 * `/user-groups/{userId}/groups` returns, and the technical admin path is invisible too — so the
 * search endpoint answers the question instead: it succeeds only for someone allowed to use it.
 * The endpoint rejects anything under 2 characters, hence a term rather than an empty call; its
 * results are never displayed.
 */
export const IMPERSONATION_PROBE_TERM = 'aa';
